import * as React from 'react'
import * as Styles from './FreeLectureList.style'
import FreeLectureType from '../../types/FreeLectureType'
// tslint:disable-next-line
const {LazyLoadImage} = require('react-lazy-load-image-component')

interface IFreeLectureList {
    lectureList: FreeLectureType.IRecommends[],
    goLecture: (url: string, id: number) => void
}

export default class FreeLectureList extends React.Component <IFreeLectureList> {
    constructor(props: IFreeLectureList) {
        super(props)
    }

    public goLectureUrl = (url: string, id: number, event: any) => {
        this.props.goLecture(url, id)
    }

    public render() {
        return (
            <div>
                {this.props.lectureList.length > 0 && this.props.lectureList.map((item: FreeLectureType.IRecommends) => (
                <div className={Styles.freeLectureListBox} onClick={this.goLectureUrl.bind(this, item.url, item.id)} key={item.id}>
                    <div className={Styles.freeLectureListItem}>
                        <div className={Styles.currentItemLeftBox}>
                            <div className={Styles.currentItemLeft}>
                                <div className={Styles.currentItemImg}>
                                    <LazyLoadImage
                                        alt={item.cover}
                                        effect="blur"
                                        src={item.cover}
                                    />
                                </div>
                                <div className={Styles.currentItemRightBottomLeftContent}>
                                    <div className={Styles.studyNum}>
                                        <img src="https://static-1253442168.image.myqcloud.com/picture/10490565_5ddfe21b03842fa68973218ec2737646.jpg" alt=""/>
                                        <span>{item.popular >= 10000 ? (item.popular / 10000).toFixed(2) + '万' : item.popular}人</span>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        <div className={Styles.currentItemRight}>
                            <div className={Styles.currentItemRightTitle}>
                                {item.name}
                            </div>
                        </div>
                        <div className={Styles.currentItemRightContainer}>
                            <div className={Styles.currentItemRightBottom}>
                                <div>
                                    立即学
                                </div>
                            </div>
                        </div>
                    </div>
                </div>))}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/FreeLecture/components/FreeLectureLise/FreeLectureList.tsx